export default "__VITE_ASSET__26387f56__"